import { atom, useAtom } from "jotai";
import { PatientId } from "../schema/schema";

const patientTaskHistoryAtom = atom<{ patientId: PatientId } | null>(null);

export function usePatientTaskHistory() {
  const [state, setState] = useAtom(patientTaskHistoryAtom);

  return {
    state,
    open: (patientId: PatientId) => setState({ patientId }),
    close: () => setState(null),
  };
}
